/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const ZaloNotificationSettingPage = lazyLoad(
  () => import('./index'),
  module => module.ZaloNotificationSettingPage
);
